module.exports = __webpack_public_path__ + "img/yunshangchuan.04bc9d18.png";